import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Table, {
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "material-ui/Table";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import Loader from "../../../Parts/Loader";
import ArrowLeft from "../../../Icons/ArrowLeft";
import NotificationBar from "../../../Parts/NotificationBar.jsx";

import {
  SalesforceJobState,
  SalesforceExportType,
} from "../../../../constants/ComponentTypes";

import * as moment from "moment";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  body: {
    width: "100%",
    margin: "10px 0px 90px 0px",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  section: {
    paddingBottom: "50px",
    width: "100%",
  },

  sectionType: {
    fontWeight: "bold",
    marginBottom: "2px",
    color: "#71737B",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "40px",
  },

  desc: {
    marginTop: "5px",
    color: "#181819",
  },

  table: {
    width: "100%",
  },

  firstCol: {
    width: "30%",
    fontWeight: "bold",
    fontSize: "15px",
    padding: "30px 10px",
  },

  secondCol: {
    width: "70%",
    fontSize: "15px",
    padding: "30px 10px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "underline",
  },

  tableHead: {
    background: "#f2f3f3",
  },

  tableHeadCell: {
    padding: "24px 12px",
    color: "#181819",
    fontWeight: "bold",
    fontSize: "12px",
  },

  tableCell: {
    padding: "15px 12px",
    color: "#181819",
    fontSize: "11px",
  },

  subsectionHead: {
    width: "100%",
    padding: "20px 0px",
    borderBottom: "1px solid #E7E9EB",
  },

  subsectionHeadTitle: {
    fontSize: "15px",
    fontWeight: "bold",
  },

  empty: {
    width: "100%",
    padding: "24px 5px",
    fontSize: "13px",
    color: "#5A5B62",
  },
});

class SalesforceExportHistoryDetail extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceExportHistoriesById(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  displayJobState = (state) => {
    let text = "-";
    let jobState = Object.values(SalesforceJobState).find(
      (item) => item.value === state
    );

    if (jobState) {
      text = jobState.text;
    }
    return text;
  };

  displayExportType = (type) => {
    let text = "-";

    let exportType = Object.values(SalesforceExportType).find(
      (item) => item.value === type
    );

    if (exportType) {
      text = exportType.text;
    }

    return text;
  };

  displayExportObjects = (item) => {
    if (item && item.salesforce_jobs) {
      if (item.salesforce_jobs.length > 0) {
        return item.salesforce_jobs.map((job, i) => <div key={i}>{job.sobject_name}</div>);
      } else {
        let exportType = Object.values(SalesforceExportType).find(
          (type) => type.value === item.type
        );
        if (exportType) {
          return exportType.sobject
        }
      }
    }
    return "-";
  };

  calcRecordCount = (item) => {
    let count = 0;

    if (item && item.salesforce_jobs.length > 0) {
      count = item.salesforce_jobs.reduce((sum, curr) => {
        if (
          curr &&
          curr.hasOwnProperty("num_processed") &&
          !isNaN(curr["num_processed"])
        ) {
          return sum + curr.num_processed;
        } else {
          return sum;
        }
      }, 0);
    } else {
      let detail = item.detail ? JSON.parse(item.detail) : null;
      if (detail && detail.hasOwnProperty("total_num_processed")) {
        count = detail["total_num_processed"];
      }
    }

    return count;
  };

  calcDuration = (start, finish) => {
    if (!start || !finish) {
      return "-";
    }

    let diff = moment(finish).diff(moment(start));
    return moment.utc(diff).format("HH:mm:ss");
  };

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderRow = (item, key) => (
    <TableRow key={key}>
      <TableCell className={this.props.classes.firstCol}>
        {item.field}
      </TableCell>
      <TableCell className={this.props.classes.secondCol}>
        {(() => {
          if (item && item.link) {
            return (
              <a
                className={this.props.classes.link}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.value}
              </a>
            );
          } else {
            return item.value;
          }
        })()}
      </TableCell>
    </TableRow>
  );

  renderRows = () => {
    const { exportHistory } = this.props;

    if (exportHistory !== null || exportHistory !== undefined) {
      let table = [
        { field: "ジョブID", value: exportHistory.id },
        {
          field: "ジョブタイプ",
          value: this.displayExportType(exportHistory.type),
        },
        {
          field: "オブジェクト",
          value: this.displayExportObjects(exportHistory),
        },
        {
          field: "ステータス",
          value: this.displayJobState(exportHistory.state),
        },
        {
          field: "開始時刻",
          value: exportHistory.instructed_at
            ? moment(exportHistory.instructed_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        },
        {
          field: "終了時刻",
          value: exportHistory.finish_at
            ? moment(exportHistory.finish_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        },
        {
          field: "完了までの時間",
          value: this.calcDuration(
            exportHistory.instructed_at,
            exportHistory.finish_at
          ),
        },
        {
          field: "バッチ数",
          value: exportHistory.salesforce_jobs.length,
        },
        {
          field: "処理済みレコード数",
          value: this.calcRecordCount(exportHistory)
        },
        {
          field: "詳細",
          value: exportHistory.message ? exportHistory.message : "-",
        },
      ];

      return table.map((item, i) => this.renderRow(item, i));
    }
  };

  renderJobsTableRow = (item, key) => {
    const { classes } = this.props;

    return (
      <TableRow key={key}>
        <TableCell className={classes.tableCell}>
          {item.salesforce_job_id}
        </TableCell>
        <TableCell className={classes.tableCell}>{item.sobject_name}</TableCell>
        <TableCell className={classes.tableCell}>{item.state}</TableCell>
        <TableCell className={classes.tableCell}>{item.operation}</TableCell>
        <TableCell className={classes.tableCell}>
          {item.instructed_at
            ? moment(item.instructed_at).format("YYYY-MM-DD HH:mm:ss")
            : "-"}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {item.finish_at
            ? moment(item.finish_at).format("YYYY-MM-DD HH:mm:ss")
            : "-"}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {item.num_processed}
        </TableCell>
        <TableCell className={classes.tableCell}>{item.num_failed}</TableCell>
        <TableCell className={classes.tableCell}>
          {item.upload_file_name && item.upload_file_path ? (
            <a
              className={classes.link}
              href={item.upload_file_path}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.upload_file_name}
            </a>
          ) : (
            "-"
          )}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {item.failed_log_name && item.failed_log_path ? (
            <a
              className={classes.link}
              href={item.failed_log_path}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.failed_log_name}
            </a>
          ) : (
            "-"
          )}
        </TableCell>
      </TableRow>
    );
  };

  renderJobsTable = () => {
    const { classes, exportHistory } = this.props;

    if (!!exportHistory && exportHistory.salesforce_jobs.length > 0) {
      return (
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableHeadCell}>ID</TableCell>
              <TableCell className={classes.tableHeadCell}>
                オブジェクト
              </TableCell>
              <TableCell className={classes.tableHeadCell}>状況</TableCell>
              <TableCell className={classes.tableHeadCell}>演算子</TableCell>
              <TableCell className={classes.tableHeadCell}>開始時刻</TableCell>
              <TableCell className={classes.tableHeadCell}>終了時刻</TableCell>
              <TableCell className={classes.tableHeadCell}>
                処理済みのレコード数
              </TableCell>
              <TableCell className={classes.tableHeadCell}>
                更新失敗のレコード数
              </TableCell>
              <TableCell className={classes.tableHeadCell}>データ</TableCell>
              <TableCell className={classes.tableHeadCell}>エラーログ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {exportHistory.salesforce_jobs.map((item, i) =>
              this.renderJobsTableRow(item, i)
            )}
          </TableBody>
        </Table>
      );
    }
  };

  renderSubsectionHead = (title) => {
    const { classes } = this.props;
    return (
      <div className={classes.subsectionHead}>
        <Typography variant="title" className={classes.subsectionHeadTitle}>
          {title}
        </Typography>
      </div>
    );
  };

  render() {
    const { classes, exportHistory } = this.props;
    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="同期履歴"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          <div className={classes.overview}>
            <div
              className={classes.progressbar}
              style={{ justifyContent: "flex-start" }}
            >
              <Button
                className={classes.returnBtn}
                onClick={() =>
                  this.props.goTo("/setting/integrations/salesforce")
                }
              >
                <ArrowLeft
                  color="#71737B"
                  width={14}
                  height={14}
                  style={{ marginRight: "6px" }}
                />
                <span>戻る</span>
              </Button>
            </div>
            <div className={classes.heading}>
              <Typography variant="title" className={classes.title}>
                Salesforce同期履歴
              </Typography>
            </div>
            {(() => {
              if (
                this.props.isLoadingExportHistory ||
                this.props.exportHistory === null
              ) {
                return (
                  <div className={classes.box}>
                    <Loader type="color" />
                  </div>
                );
              } else {
                return (
                  <div className={classes.body}>
                    <div className={classes.box} style={{ minHeight: "unset" }}>
                      <div className={classes.section}>
                        <Typography
                          variant="body2"
                          className={classes.sectionType}
                        >
                          Salesforceエクスポート履歴の詳細
                        </Typography>
                        <Typography
                          variant="display3"
                          className={classes.sectionTitle}
                        >
                          JOB ID: {this.props.match.params.id}
                        </Typography>
                        <Typography
                          variant="subheading"
                          className={classes.desc}
                        >
                          Salesforceへの一括データ書き出しジョブの詳細を参照します。
                        </Typography>
                      </div>
                      <Table className={classes.table}>
                        <TableBody>{this.renderRows()}</TableBody>
                      </Table>
                    </div>
                    <div
                      className={classes.box}
                      style={{ minHeight: "unset", overflow: "scroll" }}
                    >
                      <div>
                        {this.renderSubsectionHead("バッチ詳細")}

                        {exportHistory.salesforce_jobs.length > 0 ? (
                          this.renderJobsTable()
                        ) : (
                          <div className={classes.empty}>
                            バッチがありません。
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}
          </div>
        </div>
      </Wrapper>
    );
  }
}

SalesforceExportHistoryDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  getUserInfo: PropTypes.func,
  goTo: PropTypes.func,
  isLoadingExportHistory: PropTypes.bool,
  exportHistory: PropTypes.object,
  getSalesforceExportHistoriesById: PropTypes.func,
  match: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
};

export default withStyles(styles)(SalesforceExportHistoryDetail);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceExportHistory/SalesforceExportHistoryDetail.jsx